const footerClickTracking = {
  action: 'click',
  category: 'footer_navigation',
  type: 'footer_item',
  label: '',
};

export { footerClickTracking };
